import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Item from './Item'
import bemClass from './../../../utils/bemClass'

import './Bullets.css'

const cn = bemClass('Bullets')

class Bullets extends PureComponent {
    render() {
        const { className, length, active, onSetActive } = this.props

        return (
            <div className={`${cn()} ${className}`}>
                {Array.from({ length }).map((item, key) => (
                    <Item
                        key={key}
                        id={key}
                        active={active === key}
                        onClick={onSetActive}
                        forceRender={active}
                    />
                ))}
            </div>
        )
    }
}

Bullets.propTypes = {
    className: PropTypes.string,
    length: PropTypes.number,
    active: PropTypes.number,
    onSetActive: PropTypes.func,
}

Bullets.defaultProps = {
    onSetActive: () => {},
}

export default Bullets



// WEBPACK FOOTER //
// ./src/components/Slider/Bullets/Bullets.jsx